/**
 * The one publish-time format in the authoring app: `Aug 10, 2026 at 2:48 PM`.
 *
 * Shared rather than copied because these render next to each other. An author moves
 * between the course editor's publish banner, the questionnaire row's delivery badge and
 * the resource lines inside its readiness panel — a published-at time means the same
 * thing on all three, and two spellings of it invite the reader to look for a difference
 * that is not there.
 *
 * Returns `null` rather than a placeholder when there is nothing to format. The callers
 * disagree on what absence should look like, and that disagreement is legitimate: a
 * banner showing a bare field wants `—`, while text reading "Published to CDN …" wants
 * nothing at all, because a dash there says the deploy happened at "nothing" instead of
 * saying the time is unknown. Returning null keeps that decision where it belongs.
 */
export function formatDateTime(iso: string | null | undefined): string | null {
    if (!iso) return null;
    const date = new Date(iso);
    if (Number.isNaN(date.getTime())) return null;
    const day = date.toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
    const time = date.toLocaleTimeString(undefined, { hour: 'numeric', minute: '2-digit' });
    return `${day} at ${time}`;
}
